import * as React from 'react';

import * as ReactDOM from 'react-dom/client';

import { App } from './app';
import { enableMocking } from './mocks';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}
// Static import on purpose: the whole module graph then loads BEFORE this body runs,
// so those requests reach msw's Service Worker while it is still passing everything
// through — after MOCK_ACTIVATE it round-trips every request to the page to match
// handlers, which in dev means hundreds of module requests paying for it.
// The mock/loader race is handled in router.tsx instead: the router — and therefore
// the first loader run — is created on render, which happens below, after start().
// eslint-disable-next-line @typescript-eslint/no-floating-promises
enableMocking().then(() => {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
